import React from "react";
import { Box, Typography, MenuItem, Grid, Pagination } from "@mui/material";
import Field from "../components/common/Field/Fi";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import SearchIcon from "@mui/icons-material/Search";
import seller_mob from "../assets/images/seller_mob.png";
import eq from "../assets/images/equipo.png";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import useMediaQuery from "@mui/material/useMediaQuery";
import sort from "../assets/svgs/sort.svg";
import Button from "../components/common/Button/Button";
import Swipe from "../components/common/GalleryComponent/Swipe";
import BottomSortModal from "../components/common/Modal/BottomSortModal";
import BreadCrumbs from "../components/common/BreadCrumbs/BreadCrumbs";

const filters = [
  { label: "Best Match", val: "bm" },
  { label: "Price (High)", val: "ph" },
  { label: "Price (Low)", val: "pl" },
  { label: "Hours (Most)", val: "hm" },
  { label: "Hours (Least)", val: "hl" },
  { label: "Year (Newest)", val: "yn" },
  { label: "Year (Oldest)", val: "yo" },
];

export default function SellerList() {
  const mobMatch = useMediaQuery("(max-width:600px)");
  const [searchVal, setSearchVal] = React.useState("");
  const [sortVal, setSortVal] = React.useState(filters[0].val);
  const [showSortBy, setShowSortBy] = React.useState(false);
  const [page, setPageNo] = React.useState(1);

  const pageNext = () => {
    if (page < 10) setPageNo((old) => old + 1);
  };

  const pagePrev = () => {
    if (page > 1) setPageNo((old) => old - 1);
  };
  const toggleDrawerSort = (open) => (event) => {
    if (
      event &&
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }

    setShowSortBy(open);
  };
  const handleSortVal = (e) => {
    setSortVal(e.target.value);
  };
  return (
    <Box
      sx={{
        backgroundColor: "white",
        marginBottom: { xs: "16px", sm: "none" },
        borderRadius: "8px",
        boxShadow: {
          xs: "0px 1px 1px rgba(0, 0, 0, 0.14), 0px 2px 1px rgba(0, 0, 0, 0.12), 0px 1px 3px rgba(0, 0, 0, 0.2)",
          sm: "none",
        },
      }}
    >
      <Box
        sx={{
          display: { xs: "none", sm: "block" },
          height: "1px",
          width: "100%",
          backgroundColor: "#D6D6D6",
        }}
      ></Box>
      <Box
        sx={{
          marginTop: { xs: 0, sm: "32px" },
          marginX: { xs: "auto", lg: "0" },
          marginLeft: { xs: "auto", lg: "240px" },
          width: { xs: "100%", sm: "90%", lg: "72.26%" },
          paddingX: { xs: "16px", sm: "0" },
        }}
      >
        <Box
          sx={{
            display: { xs: "none", sm: "block" },
          }}
        >
          <BreadCrumbs breadCrumbList={["Seller Profiles"]} />
        </Box>
        {mobMatch && (
          <ArrowBackIcon
            sx={{
              color: "primary.main",
              marginLeft: "8px",
              marginTop: "28px",
              marginBottom: "32px",
            }}
          />
        )}
        <Box
          sx={{
            marginTop: { xs: 0, sm: "32px" },
            marginBottom: "4px",
            display: "flex",
            width: "100%",
            justifyContent: "space-between",
          }}
        >
          <Typography
            variant={mobMatch ? "h3" : "h2"}
            fontWeight={mobMatch ? "600" : "700"}
            fontSize={mobMatch ? "22px" : "32px"}
            lineHeight={mobMatch ? "26px" : "36px"}
            color="text.primary"
          >
            Seller Profiles
          </Typography>
          {mobMatch ? (
            <MobButtons
              onClick={toggleDrawerSort(true)}
              text="Sort by"
              icon={
                <img
                  src={sort}
                  alt="sort"
                  style={{ color: "#1F1F1F", marginRight: "4px" }}
                />
              }
            />
          ) : (
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <Typography
                variant="body1"
                fontWeight="400"
                fontSize="16px"
                lineHeight="24px"
                color="text.primary"
                sx={{ marginRight: "8px" }}
              >
                Sort by
              </Typography>
              <Field
                value={sortVal}
                handleChange={handleSortVal}
                label=""
                height="36px"
                star={false}
                endIcon={<KeyboardArrowDownIcon sx={{ color: "#808080" }} />}
                sx={{ width: "150px" }}
                select={true}
                filled={false}
              >
                {filters.map((f) => (
                  <MenuItem key={f.val} value={f.val}>
                    {f.label}
                  </MenuItem>
                ))}
              </Field>
            </Box>
          )}
        </Box>
        <Typography
          variant="body2"
          fontWeight="400"
          fontSize="14px"
          lineHeight="20px"
          color="#616161"
          sx={{ marginBottom: { xs: "24px", sm: "32px" } }}
        >
          1,200 results
        </Typography>
        <Field
          value={searchVal}
          handleChange={(e) => setSearchVal(e.target.value)}
          size="small"
          label="Search any seller"
          height="46.29px"
          sx={{ width: "100%" }}
          endIcon={<SearchIcon sx={{ color: "#808080" }} />}
        />
        <Box sx={{ height: { xs: "24px", sm: "32px" } }}></Box>
        <Grid
          container
          rowSpacing={{ xs: "16px", sm: "24px" }}
          columnSpacing={{ xs: "0", sm: "24px" }}
        >
          {Array.from(Array(20)).map((_, index) => (
            <Grid item xs={12} sm={6} md={4} xl={3} key={index}>
              {<Card mobMatch={mobMatch} />}
            </Grid>
          ))}
        </Grid>
        <Box sx={{ width: "100%", display: "flex", justifyContent: "center" }}>
          {mobMatch ? (
            <Box
              sx={{
                marginTop: "24px",
                marginBottom: "24px",
                display: "flex",
                columnGap: "16px",
              }}
            >
              <Swipe direction="left" opacity={1} onClick={pagePrev} />
              <Button
                variant="contained"
                sx={{
                  maxWidth: 32,
                  maxHeight: 32,
                  minWidth: 32,
                  minHeight: 32,
                  borderRadius: "50%",
                  opacity: 1,
                  backgroundColor: "text.primary",
                  color: "white",
                }}
              >
                {page}
              </Button>
              <Swipe direction="right" opacity={1} onClick={pageNext} />
            </Box>
          ) : (
            <Box
              sx={{
                display: "flex",
                width: "100%",
                alignItems: "center",
                flexDirection: "column",
                marginBottom: "72px",
              }}
            >
              <Pagination
                count={99}
                sx={{
                  marginTop: "72px",
                  marginBottom: "22px",
                  "& .MuiPaginationItem-root": {
                    color: "#1F1F1F",
                    "&:hover": {
                      background: "#EBEBEB",
                    },
                  },

                  "& .Mui-selected": {
                    backgroundColor: "#1F1F1F !important",
                    color: "#FFF",
                    "&:hover": {
                      backgroundColor: "#1F1F1F !important",
                      color: "#FFF",
                    },
                  },
                }}
              />
              <Typography
                variant="caption"
                fontWeight="400"
                fontSize="12px"
                lineHeight="16px"
                color="text.primary"
              >
                1-20 of 1,200 Sellers
              </Typography>
            </Box>
          )}
        </Box>
      </Box>
      <BottomSortModal open={showSortBy} toggleDrawer={toggleDrawerSort} />
    </Box>
  );
}

function MobButtons({ text, icon, onClick }) {
  return (
    <Box
      onClick={onClick}
      sx={{
        width: "83px",
        height: "36px",
        border: "1px solid #BFBFBF",
        borderRadius: "4px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: "white",
        padding: "8px auto",
      }}
    >
      {icon}
      <Typography
        variant="body2"
        fontWeight="400"
        fontSize="14px"
        lineHeight="20px"
        color="text.primary"
      >
        {text}
      </Typography>
    </Box>
  );
}

function Card({ mobMatch }) {
  return (
    <Box
      sx={{
        position: "relative",
        width: { xs: "343px", sm: "100%" },
        height: { xs: "259px", sm: "367px" },
        borderRadius: "8px",
        border: "1px solid #D6D6D6",
      }}
    >
      <img
        src={seller_mob}
        width={mobMatch ? "343px" : "100%"}
        height="155px"
        style={{ objectFit: "cover", borderRadius: "8px 8px 0px 0px" }}
      />
      <Box
        sx={{
          boxShadow: "inset 0px 0px 2px rgba(0, 0, 0, 0.25)",
          position: "absolute",
          width: "60px",
          height: "60px",
          borderRadius: "8px",
          backgroundColor: "white",
          top: "111px",
          left: "16px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <img src={eq} width="44px" height="44px" />
      </Box>
      <Box sx={{ marginTop: "32px", paddingX: "16px", marginBottom: "24px" }}>
        <Typography
          variant="subtitle1"
          fontFamily="Inter"
          fontSize="16px"
          lineHeight="24px"
          fontWeight="600"
          color="text.primary"
        >
          Equippo
        </Typography>
        <Typography
          variant="body2"
          fontFamily="Inter"
          fontSize="14px"
          lineHeight="20px"
          fontWeight="400"
          color="#616161"
          sx={{
            display: { xs: "none", sm: "block" },
            marginTop: "8px",
            marginBottom: "24px",
            width: "102%",
          }}
        >
          We are a sales team with extensive experience from various fields in
          the sale of construction and in a 118 characters.
        </Typography>
        <Typography
          variant="subtitle2"
          fontWeight="600"
          fontSize="14px"
          lineHeight="20px"
          color="primary.main"
          sx={{
            marginTop: { xs: "4px", sm: "0" },
            "&:hover": {
              textDecoration: "underline",
              cursor: "pointer",
            },
          }}
        >
          View 116 machinery
        </Typography>
      </Box>
    </Box>
  );
}
